export default "/images/vendor/flag-icon-css/flags/4x3/aw.svg?98298192f432c6fc56cc1899a86b8d04";